import Analytics from '@/utils/analytics';
import { gql, useMutation } from '@apollo/client';
import { openWebBrowserURL } from '@/utils/navigation';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useCallback } from 'react';
import { ViewInvoiceMutation, ViewInvoiceMutationVariables } from '@/types';

export const VIEW_INVOICE_MUTATION = gql`
  mutation ViewInvoice($orderInvoiceUUID: uuid!) {
    update_order_invoices_by_pk(
      pk_columns: { uuid: $orderInvoiceUUID }
      _set: { seen: true }
    ) {
      seen
      uuid
    }
  }
`;

export const useGetOpenInvoicePDF = (
  invoiceURL: string | null | undefined,
  invoiceUUID: string | null | undefined,
  seen: boolean | undefined,
) => {
  const { supplierEmployeeRole } = useAuthenticatedUserContext();
  const [markInvoiceAsSeen] = useMutation<
    ViewInvoiceMutation,
    ViewInvoiceMutationVariables
  >(VIEW_INVOICE_MUTATION);

  return useCallback(async () => {
    if (!invoiceURL || !invoiceUUID || seen === undefined) {
      return;
    }

    Analytics.track('invoice.view_pdf', {
      orderInvoiceUUID: invoiceUUID,
    });
    // Set source to prevent the app banner from rendering
    await openWebBrowserURL(`${invoiceURL}?source=app`);

    if (!seen && !supplierEmployeeRole) {
      try {
        await markInvoiceAsSeen({
          variables: {
            orderInvoiceUUID: invoiceUUID,
          },
        });
      } catch {
        // don't show toast, fail silently to user
      }
    }
  }, [invoiceURL, invoiceUUID, markInvoiceAsSeen, seen, supplierEmployeeRole]);
};
